import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// @ts-ignore - css import handled via CDN emulation + <style> in index.html for Pages build (postcss noop)
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
